import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

const J: React.FC = () => {
    const { t } = useLang('ces2026.J');

    return (
        <div id="ces-2026-J" className={`ces-2026-J ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-J'}>
            <div className="box-inner">
                <div className="img">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1765422250594/J.jpg" />
                </div>
                <div className="info">
                    <p className="title">{t('title')}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <path
                            d="M23.9958 0C20.7607 0.022796 17.6045 1.00034 14.9229 2.81C12.2413 4.61967 10.1538 7.18087 8.92222 10.1724C7.69062 13.1638 7.36979 16.4524 7.99997 19.6255C8.63014 22.7986 10.1833 25.715 12.4645 28.0089L23.9958 39.6121L35.5304 28.0089C37.8107 25.7146 39.3629 22.7982 39.9923 19.6254C40.6217 16.4525 40.3003 13.1645 39.0684 10.1735C37.8365 7.18262 35.749 4.62198 33.0676 2.81274C30.3862 1.00351 27.2304 0.0262171 23.9958 0.00342783V0ZM23.9958 23.6966C23.041 23.6944 22.096 23.5041 21.2148 23.1367C20.3336 22.7692 19.5333 22.2318 18.8598 21.5551C18.1863 20.8783 17.6526 20.0756 17.2893 19.1926C16.926 18.3097 16.7402 17.3638 16.7425 16.4091C16.7397 15.4544 16.9252 14.5087 17.2881 13.6257C17.651 12.7428 18.1843 11.94 18.8576 11.2633C19.5308 10.5865 20.3308 10.049 21.2119 9.68152C22.0929 9.31403 23.0377 9.12372 23.9923 9.12147C24.9471 9.12372 25.8921 9.314 26.7733 9.68146C27.6545 10.0489 28.4548 10.5863 29.1283 11.2631C29.8018 11.9398 30.3355 12.7425 30.6988 13.6255C31.0621 14.5084 31.2479 15.4543 31.2456 16.4091C31.2502 18.3352 30.4899 20.1844 29.1317 21.5502C27.7736 22.9161 25.9288 23.6869 24.0026 23.6932L23.9958 23.6966ZM16.7425 44.9492C16.7425 46.6323 19.9886 47.9966 23.9958 47.9966C28.0029 47.9966 31.2491 46.6254 31.2491 44.9492C31.2491 43.273 28.0029 41.9019 23.9958 41.9019C19.9886 41.9019 16.7459 43.2593 16.7459 44.9424L16.7425 44.9492Z"
                            fill="white"
                        />
                    </svg>
                    <p className="desc">{t('desc')}</p>
                </div>
            </div>
        </div>
    );
};

export default J;
